import React from "react";
import { DateTime } from "luxon";
import { DETECTION_TYPES } from "./sanctionConstants";

const EpHistoryList = ({ epHistory = [] }) => {
  if (!epHistory || epHistory.length === 0) {
    return (
      <div className=" border-left-success">
        <p
          className="mb-0"
          style={{ fontSize: 14, color: "#6c757d", fontStyle: "italic" }}
        >
          ✓ Aucun antécédent EP connu pour cet allocataire (compteur depuis le
          01/06/2025)
        </p>
      </div>
    );
  }

  const getDetectionBadge = (detectionType) => {
    switch (detectionType) {
      case DETECTION_TYPES.PREMIER:
        return (
          <span
            className="badge"
            style={{
              display: "inline-block",
              marginTop: 5,
              padding: "3px 8px",
              background: "#d1ecf1",
              color: "#0c5460",
              borderRadius: 3,
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            ℹ️ PREMIER MANQUEMENT
          </span>
        );
      case DETECTION_TYPES.PERSISTANCE:
        return (
          <span
            className="badge"
            style={{
              display: "inline-block",
              marginTop: 5,
              padding: "3px 8px",
              background: "#fff3cd",
              color: "#856404",
              borderRadius: 3,
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            🟠 PERSISTANCE (2ème manquement)
          </span>
        );
      case DETECTION_TYPES.REITERATION:
        return (
          <span
            className="badge"
            style={{
              display: "inline-block",
              marginTop: 5,
              padding: "3px 8px",
              background: "#f8d7da",
              color: "#721c24",
              borderRadius: 3,
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            🔴 RÉITÉRATION (même motif que l'EP précédente)
          </span>
        );
      default:
        return null;
    }
  };

  const getMonthsDiff = (date) => {
    const epDate = DateTime.fromISO(date);
    const now = DateTime.local();
    const diff = now.diff(epDate, "months").toObject();
    return Math.floor(diff.months);
  };

  return (
    <div className="d-flex flex-column" style={{ gap: 10 }}>
      {epHistory.map((ep, index) => {
        const monthsAgo = getMonthsDiff(ep.epDate);
        const epDateFormatted = DateTime.fromISO(ep.epDate).toFormat(
          "dd/MM/yyyy",
        );
        const notifDateFormatted = DateTime.fromISO(
          ep.notificationDate,
        ).toFormat("dd/MM/yyyy");

        return (
          <div
            key={index}
            className="p-3 bg-white rounded"
            style={{ border: "1px solid #dee2e6" }}
          >
            <div style={{ fontSize: 12, color: "#856404", fontWeight: 600 }}>
              EP du {epDateFormatted} (il y a {monthsAgo} mois) - Notification
              le {notifDateFormatted}
            </div>
            <div style={{ fontSize: 13, color: "#333", marginTop: 3 }}>
              <strong>Type:</strong> {ep.sanctionType}
              <br />
              <strong>Décision:</strong> {ep.decision}
              <br />
              <strong>Motif principal:</strong> {ep.mainReason}
              <br />
              {getDetectionBadge(ep.detectionType)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EpHistoryList;
